import { App } from '@ui/App';
import { render } from 'preact';
import '@ui/tokens.css';
import '@ui/components.css';

const root = document.getElementById('app');
if (!root) throw new Error('Root element #app not found');
render(<App />, root);

// PWA (F4): service worker só em produção — em dev atrapalha o HMR
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[pwa] service worker falhou:', err);
    });
  });
}
